/**
 * The success toasts of the connections export and import (security-slice review round 2, Codex #9 / Fable N1): they
 * say what travelled and, when a password written inside a connection's own text could not travel or be put back
 * exactly, which connections need it again — never "restored" for a text that was not.
 */

const plural = (count: number, one: string, many: string) => `${count} ${count === 1 ? one : many}`;

export function exportToastDescription(result: { withSecrets: boolean; targetsLeftStripped: number }): string {
  const base = result.withSecrets
    ? 'Saved passwords are in the file, encrypted with your passphrase. Nothing is readable without it.'
    : 'No passwords are in that file. Server names and usernames are, in plain text.';
  if (result.targetsLeftStripped === 0) return base;
  const one = result.targetsLeftStripped === 1;
  return `${base} ${plural(result.targetsLeftStripped, 'connection has', 'connections have')} a password inside ${one ? 'its' : 'their'} connection text that could not be carried exactly; it shows as *** and must be entered again after import.`;
}

export function importToastDescription(result: { secretsRestored: number; targetsNotRestored: string[] }): string {
  const base = result.secretsRestored > 0
    ? `${plural(result.secretsRestored, 'saved secret', 'saved secrets')} restored on this machine.`
    : 'Passwords were not included — you will be asked on first connect.';
  if (result.targetsNotRestored.length === 0) return base;
  return `${base} The password inside the connection text of ${result.targetsNotRestored.join(', ')} could not be restored; enter it again.`;
}
